import { Controller } from "@hotwired/stimulus"

const PLAYED_KEY = "assistant_spoken_turns"

// Plays the most recent assistant reply aloud when it was initiated by voice
// (walkie-talkie). Dedupes within the tab session so replies aren't repeated
// on reloads or poll refreshes.
export default class extends Controller {
    connect() {
        this._playLatest()
    }

    _playLatest() {
        const nodes = Array.from(this.element.querySelectorAll("[data-speak='true'][data-turn-id]"))
        if (!nodes.length) return

        const played = this._playedSet()
        const target = nodes.reverse().find((n) => !played.has(n.dataset.turnId))
        if (!target) return

        const id = target.dataset.turnId
        this._markPlayed(id)

        const audio = new Audio(`/assistant/speak?turn_id=${encodeURIComponent(id)}`)
        audio.play().catch(() => this._showTapToPlay(target, id))
    }

    _showTapToPlay(bubble, id) {
        if (bubble.querySelector(".assistant-speak-play")) return
        const btn = document.createElement("button")
        btn.type = "button"
        btn.className = "assistant-speak-play"
        btn.innerHTML = "<i class=\"bi bi-volume-up\"></i> Play reply"
        btn.addEventListener("click", () => {
            const audio = new Audio(`/assistant/speak?turn_id=${encodeURIComponent(id)}`)
            audio.play().catch(() => {})
            btn.remove()
        })
        bubble.appendChild(btn)
    }

    _playedSet() {
        try {
            return new Set(JSON.parse(sessionStorage.getItem(PLAYED_KEY) || "[]"))
        } catch (e) {
            return new Set()
        }
    }

    _markPlayed(id) {
        const set = this._playedSet()
        set.add(id)
        try {
            sessionStorage.setItem(PLAYED_KEY, JSON.stringify(Array.from(set).slice(-50)))
        } catch (e) {}
    }
}
